import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
}));

export default function DailyReportsTable(props) {
  const { data, title } = props;


  
  const { t } = useTranslation(["forms"]);
  const classes = useStyles();
  const stylH = {
    BorderBottom: "solid 0.5px",
    borderColor: "black",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
    fontSize: "1rem",
    color: "#fff"
}
const stylRo = {
    BorderBottom: "solid 0.5px",
    borderColor: "gray",
    fontFamily: "Amiri-Regular",
    fontWeight: 700,
    fontSize: 14,
    color: "#000"
}
  return (
    <TableContainer component={Paper}>
      <Table 
      size="small" aria-label="a dense table">
        <TableHead>
          <TableRow
            style={{
              backgroundColor: colors.green[300],
              color: "#000",
              fontWeight: "bold",
              fontFamily: "Amiri-Regular",
              fontSize: 15,
              border: "solid 0.6px"
            }}
          >
             <TableCell style={stylH} align="center">
             {t("no")}
            </TableCell>
            <TableCell style={stylH} align="center">
            {t("movement_type")}
            </TableCell>
            <TableCell style={stylH} align="center">
              {t("number_of_invoices")}
            </TableCell>
            <TableCell style={stylH} align="center">
            {t("total")}
            </TableCell>
            <TableCell style={stylH} align="center">
            {t("cash2")}
            </TableCell>
            <TableCell style={stylH} align="center">
            {t("foward")}
            </TableCell>
            <TableCell style={stylH} align="center">
            {t("network")}
            </TableCell>
            <TableCell style={stylH} align="center">
            {t("bank2")}
            </TableCell>
            <TableCell style={stylH} align="center">
            {t("dues")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row,i) => (
            <TableRow key={row.title}
            style={{ padding: "5px 0px",
              textAlign: "-webkit-center",
              margin: "0px",
              whiteSpace: "nowrap",
              color: "#000",
              fontWeight: 800,
              fontFamily: "Amiri-Regular",
              fontSize: 15,
              border: "solid 0.6px"}}>
              <TableCell   style={stylRo} align="center">{i+1}</TableCell>
              <TableCell   style={stylRo} align="center">{row.title}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.counts}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.total?.toFixed(2)}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.total_cash?.toFixed(2)}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.total_agel?.toFixed(2)}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.total_network?.toFixed(2)}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.total_bank?.toFixed(2)}</TableCell>
              <TableCell  style={stylRo} align="center" >{row.total_emp?.toFixed(2)}</TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
